<template>
  <modal :show.sync="show" modalClasses="modal-hide-footer">
    <h3 slot="header" class="mb-0">BANKING PAYMENT RECORDS (SOURCE: CCRIS, BANK NEGARA MALAYSIA)</h3>
    <b-row>
      <!-- CCRIS Entity Key -->
      <b-col cols="12" class="mb-3">
        <b-card no-body class="custom-card">
          <b-card-body>
            <b-row>
              <b-col cols="6">
                <strong>CCRIS Entity Key:</strong> {{ ccrisEntityKey }}
              </b-col>
              <b-col cols="6">
                <strong>Subject Status:</strong> {{ subjectStatus }}
              </b-col>
            </b-row>
          </b-card-body>
        </b-card>
      </b-col>

      <!-- Main Summary Table -->
      <b-col cols="12" class="mb-3">
        <b-card no-body class="custom-card">
          <b-card-header class="py-2 px-3 custom-card-header">
            <h5 class="mb-0">BANKING PAYMENT RECORDS (SOURCE: CCRIS, BANK NEGARA MALAYSIA)</h5>
          </b-card-header>
          <b-card-body class="p-0">
            <div class="table-container">
              <table class="liabilities-table bordered summary-table">
                <thead>
                  <tr>
                    <th style="width: 40%">CCRIS SUMMARY</th>
                    <th style="width: 30%">No. of Applications</th>
                    <th style="width: 30%">Amount Applied</th>
                  </tr>
                </thead>
                <tbody>
                  <!-- Credit Applications Header -->
                  <tr class="section-header">
                    <td colspan="3"><strong>Credit Applications</strong></td>
                  </tr>
                  <!-- Approved Row -->
                  <tr>
                    <td style="padding-left: 20px;">Approved in past 12 months</td>
                    <td style="text-align: center">{{ creditApplications.approved.count || '-' }}</td>
                    <td style="text-align: center">{{ formatCurrency(creditApplications.approved.amount) }}</td>
                  </tr>
                  <!-- Pending Row -->
                  <tr>
                    <td style="padding-left: 20px;">Pending</td>
                    <td style="text-align: center">{{ creditApplications.pending.count || '-' }}</td>
                    <td style="text-align: center">{{ formatCurrency(creditApplications.pending.amount) }}</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </b-card-body>
        </b-card>
      </b-col>

      <!-- Liabilities Table -->
      <b-col cols="12" class="mb-3">
        <b-card no-body class="custom-card">
          <b-card-header class="py-2 px-3 custom-card-header">
            <h5 class="mb-0">Summary of Potential & Current Liabilities</h5>
          </b-card-header>
          <b-card-body class="p-0">
            <div class="table-container">
              <table class="liabilities-table bordered summary-table">
                <thead>
                  <tr>
                    <th style="width: 40%">Summary of Potential & Current Liabilities</th>
                    <th style="width: 20%">Outstanding</th>
                    <th style="width: 20%">Total Limit</th>
                    <th style="width: 20%">FEC Limit</th>
                  </tr>
                </thead>
                <tbody>
                  <!-- As Borrower Row -->
                  <tr>
                    <td><strong>As Borrower</strong></td>
                    <td style="text-align: center">{{ liabilitiesData.as_borrower.outstanding }}</td>
                    <td style="text-align: center">{{ liabilitiesData.as_borrower.total_limit }}</td>
                    <td style="text-align: center">{{ liabilitiesData.as_borrower.fec_limit }}</td>
                  </tr>
                  <!-- As Guarantor Row -->
                  <tr>
                    <td><strong>As Guarantor</strong></td>
                    <td style="text-align: center">{{ liabilitiesData.as_guarantor.outstanding }}</td>
                    <td style="text-align: center">{{ liabilitiesData.as_guarantor.total_limit }}</td>
                    <td style="text-align: center">{{ liabilitiesData.as_guarantor.fec_limit }}</td>
                  </tr>
                  <!-- Total Row -->
                  <tr class="total-row">
                    <td><strong>Total</strong></td>
                    <td style="text-align: center"><strong>{{liabilitiesData.total.outstanding }}</strong></td>
                    <td style="text-align: center"><strong>{{liabilitiesData.total.total_limit }}</strong></td>
                    <td style="text-align: center"><strong>{{liabilitiesData.total.fec_limit }}</strong></td>
                  </tr>
                  <!-- Legal Action Taken Row -->
                  <tr>
                    <td><strong>Legal Action Taken</strong></td>
                    <td colspan="3" style="text-align: center">{{ this.liabilities.legalActionTaken || 'N' }}</td>
                  </tr>
                  <!-- Special Attention Account Row -->
                  <tr>
                    <td><strong>Special Attention Account</strong></td>
                    <td colspan="3" style="text-align: center">{{ this.liabilities.specialAttentionAccount || 'N'}}</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </b-card-body>
        </b-card>
      </b-col>
    </b-row>
  </modal>
</template>

<script>
import Modal from "@/components/Modal";
import { Table, TableColumn } from "element-ui";

export default {
  name: "LiabilitiesModal",
  props: {
    liabilities: {
      type: Object,
      default: () => ({})
    },
  
    show_liabilities_full_view: Boolean,
  },
  components: {
    Modal,
    [Table.name]: Table,
    [TableColumn.name]: TableColumn,
  },
  data() {
    return {
      // You can add local data here if needed
    };
  },
  computed: {
    show: {
      get() {
        return this.show_liabilities_full_view;
      },
      set(value) {
        this.$emit("update:show_liabilities_full_view", value);
      },
    },
    
    // Extract nested data with fallbacks
    ccrisEntityKey() {
      return this.liabilities.ccris_entity_key || '-';
    },
    
    subjectStatus() {
      return this.liabilities.subject_status || '-';
    },
    
    creditApplications() {
      return this.liabilities.credit_applications || {
        approved: { count: '-', amount:'-' },
        pending: { count: '-', amount: '-' }
      };
    },
    
    liabilitiesData() {
      return this.liabilities.liabilities || {
        as_borrower: { outstanding: '-', total_limit: '-', fec_limit: '-' },
        as_guarantor: { outstanding: '-', total_limit: '-', fec_limit: '-' },
        total: { outstanding: '-', total_limit: '-', fec_limit: '-' }
      };
    },
    legalActionTaken() {
      return this.ccrisBankingRecords.legal_action_taken || 'N';
    },
    specialAttentionAccount() {
      return this.ccrisBankingRecords.special_attention_account || 'N';
    }
  },
  methods: {
    formatCurrency(value) {
      if (value === null || value === undefined || value === '-' || value === 0) {
        return '-';
      }
      
      // Format as currency with 2 decimal places
      return new Intl.NumberFormat('en-MY', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
      }).format(value);
    },
    
    // Safe display method to handle empty values
    safeDisplay(value) {
      if (value === null || value === undefined || value === '') {
        return '-';
      }
      
      // Handle empty arrays
      if (Array.isArray(value) && value.length === 0) {
        return '-';
      }
      
      // Handle arrays with content
      if (Array.isArray(value)) {
        return value.join(', ');
      }
      
      // Handle empty objects
      if (typeof value === 'object' && Object.keys(value).length === 0) {
        return '-';
      }
      
      // Handle string representations of empty arrays/objects
      if (typeof value === 'string' && (value === '[]' || value === '{}')) {
        return '-';
      }
      
      return value;
    }
  }
};
</script>

<style scoped>
.liabilities {
  font-family: inherit;
}

.custom-card {
  border: 1px solid #dee2e6;
  border-radius: 4px;
  margin-bottom: 0;
}

.custom-card-header {
  background-color: #f8f9fa;
  border-bottom: 1px solid #dee2e6;
}

.table-container {
  width: 100%;
  overflow-x: auto;
}

/* Styles matching directories business tables */
.liabilities-table {
  border-collapse: collapse;
  width: 100%;
  font-family: inherit;
  font-size: 0.875rem;
  margin-bottom: 0;
}

.liabilities-table.bordered,
.liabilities-table th,
.liabilities-table td {
  border: 1px solid #000 !important;
}

/* Summary table specific header styling */
.summary-table th {
  background-color: #252938 !important;
  color: #fff !important;
  border: none !important;
  vertical-align: top !important;
  text-transform: none !important;
  font-size: 14px !important;
  font-weight: 400 !important;
  line-height: 19.5px !important;
  padding: 9px 12px !important;
  text-align: center;
}

.liabilities-table td {
  background-color: #fff !important;
  color: #000 !important;
  padding: 8px 6px;
  text-align: left;
  vertical-align: middle;
}

.liabilities-table tbody tr:nth-child(even) {
  background-color: #f8f9fa;
}

.liabilities-table tbody tr:nth-child(odd) {
  background-color: #ffffff;
}

/* Section header styling */
.section-header td {
  background-color: #e9ecef !important;
  font-weight: 600;
  padding: 8px 12px;
}

.sub-header td {
  background-color: #f8f9fa !important;
  font-weight: 600;
  padding: 6px 12px;
}

.total-row {
  background-color: #e9ecef !important;
}

.total-row td {
  font-weight: 600;
}

/* Responsive adjustments */
@media (max-width: 768px) {
  .table-container {
    font-size: 0.7rem;
  }
  
  .liabilities-table th,
  .liabilities-table td {
    padding: 6px 4px;
  }
}
</style>